<template>
<!-- Testimonials -->
            <section class="review-section">
                <div class="vector-shapes">
                    <span class="shape-6"><img src="../../../assets/img/vectors/vector-5.png" alt=""></span>
                    <span class="shape-7"><img src="../../../assets/img/vectors/vector-6.png" alt=""></span>
                </div>
                <div class="container">
                    <div class="section-heading text-center">
                        <img src="../../../assets/img/icons/heading.png" alt="" class="img-fluid">
                        <h2>Reviews</h2>
                        <p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat </p>
                    </div>
                    <div class="row">
                        <div class="col-md-10 m-auto">
                            <div class="testimonial-slider">
                            <carousel :items="1" :loop="true"  :margin="15" :navText="navText" :responsive="responsive" :dots="false" class="text-center">
                               
                                    <div class="item review-card">
                                        <img src="../../../assets/img/clients/client2.jpg" class="clients m-auto" alt="">  
                                        <h6 class="name mt-4 mb-0">William  Zoe</h6>
                                        <span>uk</span> 
                                        <ul class="mb-4 review-rating mapgridrating1">
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star not-checked"></i> 
                                            </li>
                                        </ul>
                                        <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor, nunc vulputate aliquam in.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor, nunc vulputate aliquam in.</p>
                                    </div>
                                    <div class="item review-card">
                                        <img src="../../../assets/img/clients/client2.jpg" class="clients m-auto" alt="">  
                                        <h6 class="name mt-3 mb-0">William  Zoe</h6>
                                        <span>uk</span> 
                                        <ul class="mb-4 review-rating mapgridrating1">
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star checked"></i> 
                                            </li>
                                            <li>    <i class="fas fa-star not-checked"></i> 
                                            </li>
                                        </ul>
                                        <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor, nunc vulputate aliquam in.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tortor, nunc vulputate aliquam in.</p>
                                    </div>
                              </carousel> 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vector-shapes">
                    <span class="shape-5"><img src="../../../assets/img/vectors/vector-3.png" alt=""></span>
                    <span class="shape-8"><img src="../../../assets/img/vectors/vector-4.png" alt=""></span>
                </div>
            </section>
            <!-- /Testimonials -->
</template>
<script>
export default {
 data() {
        return {
            navText: ["<i class='fas fa-arrow-left owl-nav-left'></i>", "<i class='fas fa-arrow-right owl-nav-right ms-3'></i>"],
            responsive: {
            items: 1,
            autoplay: true,
            autoplayTimeout: 50000,
            
            
            }
        }
    },
}
</script>